import { render, staticRenderFns } from "./distributorList.vue?vue&type=template&id=93a63bce&scoped=true"
import script from "./distributorList.vue?vue&type=script&lang=js"
export * from "./distributorList.vue?vue&type=script&lang=js"
import style0 from "./distributorList.vue?vue&type=style&index=0&id=93a63bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a63bce",
  null
  
)

export default component.exports